<!-- 
Contents of the ACTIVITY tab of the user page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="true"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="administration-users"
      module="prismsUsers"
      nav-url="/users/:id/activity"
    />
    <tabs :user-id="userId">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search user activity"
        flat
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        color="primary"
        flat dense
        @selected="$refs.history.refresh()"
      />
      <system-log-listing
        v-if="state.loaded"
        ref="history"
        :endpoint="`/api/prisms-users/${userId}/history`" 
        :export-endpoint="`/api/exports/prisms-users/${userId}/history`"
        :export-validate-endpoint="`/api/exports/validate/prisms-users/${userId}/history`"
        hide-user-column
        embedded 
      />
    </tabs>
  </div>
</template>

<script>
import Tabs from "./Tabs.vue";
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import prismsUserMixins from "./mixins";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "UserActivity",
  components: { Tabs, SystemLogListing },
  mixins: [prismsUserMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
